import hasErrors from '@mixins/hasErrors'

const formBase = {

    mixins: [hasErrors],

    props: {
        translations: {
            type: Object,
            required: true,
        },

        googleAnalyticsEventLabel: {
            type: String,
            required: false
        },

        sharpspringEndpoint: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            processing: false, //when posting the formData
            submitted: false, //when formData is successfully submitted

            formData: null
        }
    },

    mounted() {
        this.formData.sharpspringEndpoint = this.sharpspringEndpoint;
        this.formData.googleAnalyticsEventLabel = this.googleAnalyticsEventLabel;
    },


    methods: {
        async submit(path) {
            const isValid = await this.$refs.observer.validate();
            if (isValid && path != null && path != '') {
                this.processing = true;
                axios
                    .post(path, this.formData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) this.submitted = true;
                        if (response.data.hasOwnProperty('success')) this.done = true;
                        this.clearFormFields(this.formData);

                        this.$refs.form.innerHTML = "";
                        var h5 = document.createElement('h5');
                        h5.innerHTML = this.translations.success_message;
                        this.$refs.form.appendChild(h5);

                        if (this.sendGaEvent !== undefined) {
                            this.sendGaEvent()
                        }
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            }
        },

        clearFormFields(dataObject) {
            Object.keys(dataObject).forEach(function (item) {
                if (typeof dataObject[item] === "string") item = "";
                if (typeof dataObject[item] === "object") {
                    if (Array.isArray(dataObject[item])) {
                        dataObject[item] = [];
                    } else {
                        dataObject[item] = {};
                    }
                }
            });
        }
    },
}

export default formBase;

